<template>

  <div class="card-base card-shadow--medium widget small-widget queue-widget">
    <div class="widget-value ph-10">
      <div class="flex mb-10 mt-10 align-center">
        <span class="mr-5 flex justify-center align-center">
          <v-svg width="18" height="18" class="voxo-aqua" sprite="call-outbound"/>
        </span>
        <el-input
          class="widget-name-input ml-10"
          v-model="widgetName"
        />
        <el-button
          @click="removeWidget"
          class="table-action-button ml-10"
        >
          <i class="el-icon-delete voxo-dark-red" />
        </el-button>
      </div>

      <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
        {{ completedCallbacksValue }}
      </h1>
       <div class="flex justify-space-between mb-10">
         <div class="stat-breakdown">
           <div class="text-left">
             <span> {{ successfulCallbacksValue }}</span>
           </div>
           <h5 class="mt-0 mb-0"> SUCCESS </h5>
         </div>
         <div class="stat-breakdown">
           <div class="text-right">
             <span> {{ failedCallbacksValue }}</span>
           </div>
           <h5 class="mt-0 mb-0"> TIMEOUT </h5>
         </div>
       </div>
    </div>

    <div class="stat-widget-table ph-10" v-show="isMultiQueue">
      <vxe-table
        round
        ref="xGrid"
        height="100%"
        border="inner"
        class="user-stats-table"
        empty-text="No Data"
        auto-resize
        sync-resize
        :show-overflow="true"
        :checkbox-config="{checkAll: determineCheckAll()}"
        @checkbox-change="checkboxesChanged"
        @checkbox-all="checkboxesChanged"
        :scroll-y="{enabled: true, gt: 10, oSize: 0}"
        :data="queueStoreData"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="30"
        />
        <vxe-table-column
          field="queueId"
          title="Queue"
          min-width="200"
          sortable
          :formatter="getQueueName"
        />
        <vxe-table-column
          field="completedCallbacks"
          title="Count"
          min-width="80"
          sortable
          sort-type="number"
        />
      </vxe-table>
    </div>

  </div>

</template>

<script>

import {mapGetters} from "vuex";
import {debounce} from "lodash";

export default {
  name: 'CallbacksComplete',
  props: {
    widgetIndex: {required: true},
    title: {required: true},
    filterQueueIds: {required: true},
    queueNameKey: {required: true},
  },
  data() {
    return {
      widgetName: this.title,
      completedCallbacksValue: 0,
      successfulCallbacksValue: 0,
      failedCallbacksValue: 0,
      filtersActive: false,
      filterQueues: this.filterQueueIds,
      viewStyle: 'default'
    }
  },
  computed: {

    ...mapGetters('queueDashQueues', {queueStoreData: 'list'}),

    isMultiQueue() {
      return this.queueStoreData.length > 1;
    },

    completedCallbacks() {
      return this.$store.state.queueManagerAggregates.completedCallbacks;
    },

    successfulCallbacks() {
      return this.$store.state.queueManagerAggregates.successfulCallbacks;
    },

    failedCallbacks() {
      return this.$store.state.queueManagerAggregates.failedCallbacks;
    }

  },
  watch: {
    completedCallbacks: debounce(function () {
      this.completedCallbacksValue = this.filtersActive ? this.getFilteredValue('completedCallbacks') : this.completedCallbacks;
    }, 150),
    successfulCallbacks: debounce( function () {
      this.successfulCallbacksValue = this.filtersActive ? this.getFilteredValue('successfulCallbacks') : this.successfulCallbacks;
    }, 150 ),
    failedCallbacks: debounce(function () {
      this.failedCallbacksValue = this.filtersActive ? this.getFilteredValue('failedCallbacks') : this.failedCallbacks;
    }, 150),
    widgetName: debounce(function() {
      if(this.widgetName === this.title) return;
      this.$emit('nameUpdate', {name: this.widgetName, index: this.widgetIndex});
    }, 750),
    filterQueues: debounce(function () {
      this.$emit('filterQueuesUpdate', {filterQueueIds: this.filterQueues, index: this.widgetIndex});
    }, 750)
  },
  methods: {

    getQueueName(data) {
      const { cellValue } = data;
      return this.queueNameKey[cellValue] ? this.queueNameKey[cellValue] : 'Unknown';
    },

    removeWidget(){
      this.$emit('removeWidget', this.widgetIndex);
    },

    checkboxesChanged({records}) {
      this.filterQueues = records.map(item => item.queueId);

      if(this.filterQueues.length === this.queueStoreData.length){
        this.completedCallbacksValue = this.completedCallbacks;
        this.successfulCallbacksValue = this.successfulCallbacks;
        this.failedCallbacksValue = this.failedCallbacks;
        this.filtersActive = false;
        return;
      }

      this.filtersActive = true;
      this.filterValues();
    },

    getFilteredValue(key) {
      let value = 0;
      for (let item of this.queueStoreData) {
        if (this.filterQueues.includes(item.queueId)) {
          value += item[key];
        }
      }
      return value;
    },

    filterValues() {

      let completed = 0;
      let success = 0;
      let failed = 0;

      for (let item of this.queueStoreData) {
        if (this.filterQueues.includes(item.queueId)) {
          completed += item.completedCallbacks;
          success += item.successfulCallbacks;
          failed += item.failedCallbacks;
        }
      }

      this.successfulCallbacksValue = success;
      this.failedCallbacksValue = failed;
      this.completedCallbacksValue = completed;
    },

    determineCheckAll() {

      const hasFilter = this.filterQueues.length !== this.queueStoreData.length;

      if(!hasFilter){
        this.getInitialValue();
        return true;
      }

      if(hasFilter){
        this.filtersActive = true;
        this.updateCheckboxes();
        return false;
      }

    },

    async updateCheckboxes() {
      setTimeout(() => {
        const checkedRows = this.queueStoreData.filter(item => this.filterQueues.includes(item.queueId));

        const grid = this.$refs.xGrid;
        if(grid){
          grid.setCheckboxRow(checkedRows,checkedRows);
          this.completedCallbacksValue = this.getFilteredValue('completedCallbacks');
          this.successfulCallbacksValue = this.getFilteredValue('successfulCallbacks');
          this.failedCallbacksValue = this.getFilteredValue('failedCallbacks');
        }
      }, 500)
    },

    getInitialValue() {
      setTimeout( () => {
        this.completedCallbacksValue = this.getFilteredValue('completedCallbacks');
        this.successfulCallbacksValue = this.getFilteredValue('successfulCallbacks');
        this.failedCallbacksValue = this.getFilteredValue('failedCallbacks');
      }, 500)
    }
  }
}

</script>
